import { ActionContext, Module } from "vuex";
import { catalogModule as catalog } from "./catalogModule";
import { caseManagerModule as caseManager } from "./caseManagerModule";

const URL = {};

class CaseModule implements Module<any, any> {
  namespaced = true;

  state = {};

  mutations = {};

  actions = {};

  modules = {
    catalog,
    caseManager,
  };
}

export const caseModule = new CaseModule();
